export const GA4_MEASUREMENT_ID = "G-80H8D06X0F";
export const GOOGLE_ADS_ID = "AW-18397565871";
export const GOOGLE_ADS_CONVERSION = "AW-18397565871/rexdCLLU3vAcEK-n0sRE";

const FIRED_ORDER_IDS = new Set();
const LAST_CONVERSION_KEY = "rx_aw_last_conversion";
const conversionKey = (orderId) => `google_ads_conversion_${orderId}`;

const waitForGtag = (callback, attempts = 0) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    callback();
    return;
  }
  if (attempts < 40) {
    setTimeout(() => waitForGtag(callback, attempts + 1), 50);
    return;
  }
  console.error("[Google Ads] Conversion NOT fired - gtag is not available");
};

const normalizeOrderId = (value) => {
  if (value == null || value === "") return "";
  const id = String(value).trim();
  return id && id !== "undefined" && id !== "null" ? id : "";
};

export const formatGoogleAdsValue = (value) => {
  const amount = Number.parseFloat(value);
  if (!Number.isFinite(amount) || amount <= 0) return null;
  return Math.round(amount * 100) / 100;
};

export const persistSuccessfulCheckoutConversion = ({ orderId, orderTotal }) => {
  const id = normalizeOrderId(orderId);
  const amount = formatGoogleAdsValue(orderTotal);
  if (!id || amount == null) return;
  try {
    sessionStorage.setItem(
      LAST_CONVERSION_KEY,
      JSON.stringify({ orderId: id, orderTotal: amount })
    );
  } catch (err) {
    // ignore
  }
};

export const readSuccessfulCheckoutConversion = () => {
  try {
    const raw = sessionStorage.getItem(LAST_CONVERSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const orderId = normalizeOrderId(parsed?.orderId);
    const orderTotal = formatGoogleAdsValue(parsed?.orderTotal);
    if (!orderId || orderTotal == null) return null;
    return { orderId, orderTotal };
  } catch (err) {
    return null;
  }
};

/**
 * Initial checkout confirmation only.
 * transaction_id is createOrder_test order_id.
 * Sends value, currency, transaction_id, and send_to — nothing else.
 */
export const fireGoogleAdsConversion = ({ orderId, orderTotal }) => {
  const id = normalizeOrderId(orderId);
  const amount = formatGoogleAdsValue(orderTotal);

  if (!id) {
    console.error("[Google Ads] Conversion NOT fired - missing transaction_id");
    return false;
  }
  if (amount == null) {
    console.error("[Google Ads] Conversion NOT fired - missing order total");
    return false;
  }

  const key = conversionKey(id);
  if (FIRED_ORDER_IDS.has(id)) {
    console.log("[Google Ads] Conversion already fired for this transaction_id");
    return false;
  }
  try {
    if (sessionStorage.getItem(key)) {
      FIRED_ORDER_IDS.add(id);
      console.log("[Google Ads] Conversion already fired for this transaction_id");
      return false;
    }
    sessionStorage.setItem(key, "true");
  } catch (err) {
    // continue with in-memory guard
  }

  FIRED_ORDER_IDS.add(id);

  waitForGtag(() => {
    const conversionPayload = {
      send_to: GOOGLE_ADS_CONVERSION,
      value: amount,
      currency: "USD",
      transaction_id: id,
    };
    console.log("[Google Ads] Firing conversion event");
    console.log("[Google Ads] transaction_id:", id);
    window.gtag("event", "conversion", conversionPayload);
    console.log("[Google Ads] Conversion event sent", conversionPayload);
  });

  return true;
};
